<template>
  <div class="dashboard">
    <h2>数据看板</h2>
    
    <div class="stats-grid">
      <div class="stat-card">
        <h3>作品总数</h3>
        <p class="value">128</p>
      </div>
      <div class="stat-card">
        <h3>今日收益</h3>
        <p class="value">¥1,280</p>
      </div>
      <div class="stat-card">
        <h3>总收益</h3>
        <p class="value">¥28,500</p>
      </div>
      <div class="stat-card">
        <h3>待提现金额</h3>
        <p class="value">¥5,200</p>
      </div>
    </div>

    <div class="chart-container">
      <h3>每日收入金额</h3>
      <div class="chart-placeholder">
        <!-- Chart will be rendered here -->
        <p>折线图将在此处显示</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardView'
}
</script>

<style scoped>
.dashboard {
  padding: 20px;
}

.stats-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin: 20px 0;
}

.stat-card {
  flex: 1;
  min-width: 200px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.stat-card h3 {
  margin-top: 0;
  color: #666;
  font-size: 16px;
}

.stat-card .value {
  font-size: 24px;
  font-weight: bold;
  margin: 10px 0 0;
}

.chart-container {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.chart-placeholder {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 4px;
  margin-top: 15px;
}
</style>
